import { userInfoFrag } from '../../../../utils/type/user.common-type';

export const getWorksFrag = `
    id
    serviceId
    dateFrom
    workData {
        ... on WorkDataOperationalReportObject {
            form
            shift
            type
            description
            priority
            location {
                name
            }
            users {
                ${userInfoFrag}
            }
        }
    }
`;
